export const samples = [
  {
    keyboardKey: "Q",
    name: "Vaquita",
    url: "https://www.worldwildlife.org/species/vaquita",
    type: "trigger",
    audioSample: "",
    index: 0,
  },
  {
    keyboardKey: "W",
    name: "African Wild Dog",
    url: "https://www.worldwildlife.org/species/african-wild-dog",
    index: 1,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "E",
    name: "Whale Shark",
    url: "https://www.worldwildlife.org/species/whale-shark",
    index: 2,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "R",
    name: "SumatRan Elephant",
    url: "https://www.worldwildlife.org/species/sumatran-elephant",
    index: 3,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "T",
    name: "Sumatran Orangutan",
    url: "https://www.worldwildlife.org/species/sumatran-orangutan",
    index: 4,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "Y",
    name: "Monarch Butterfly",
    url: "https://www.worldwildlife.org/species/monarch-butterfly",
    index: 5,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "U",
    name: "Bluefin Tuna",
    url: "https://www.worldwildlife.org/species/bluefin-tuna",
    index: 6,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "I",
    name: "Fin Whale",
    url: "https://www.worldwildlife.org/species/fin-whale",
    index: 7,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "O",
    name: "Bonobo",
    url: "https://www.worldwildlife.org/species/bonobo",
    index: 8,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "P",
    name: "Humphead Wrasse",
    url: "https://www.worldwildlife.org/species/humphead-wrasse",
    index: 9,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "A",
    name: "Red Panda",
    url: "https://www.worldwildlife.org/species/red-panda",
    index: 10,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "S",
    name: "Sunda Tiger",
    url: "https://www.worldwildlife.org/species/sunda-tiger",
    index: 11,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "D",
    name: "Eastern Lowland gorilla",
    url: "https://www.worldwildlife.org/species/eastern-lowland-gorilla",
    index: 12,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "F",
    name: "African Forest Elephant",
    url: "https://www.worldwildlife.org/species/african-forest-elephant",
    index: 13,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "G",
    name: "Galapagos Penguin",
    url: "https://www.worldwildlife.org/species/galapagos-penguin",
    index: 14,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "H",
    name: "North Atlantic Right Whale",
    url: "https://www.worldwildlife.org/species/north-atlantic-right-whale",
    index: 15,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "J",
    name: "Javan Rhino",
    url: "https://www.worldwildlife.org/species/javan-rhino",
    index: 16,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "K",
    name: "Hawksbill Seaturtle",
    url: "https://www.worldwildlife.org/species/hawksbill-turtle",
    index: 17,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "L",
    name: "Amur Leopard",
    url: "https://www.worldwildlife.org/species/amur-leopard",
    index: 18,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "Z",
    name: "Chimpanzee",
    url: "https://www.worldwildlife.org/species/chimpanzee",
    index: 19,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "X",
    name: "Arctic Fox",
    url: "https://www.worldwildlife.org/species/arctic-fox",
    index: 20,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "C",
    name: "Macaw",
    url: "https://www.worldwildlife.org/species/macaw",
    index: 21,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "V",
    name: "Ganges River Dolphin",
    url: "https://www.worldwildlife.org/species/ganges-river-dolphin",
    index: 22,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "B",
    name: "Black Spider Monkey",
    url: "https://www.worldwildlife.org/species/black-spider-monkey",
    index: 23,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "N",
    name: "Sea Lions",
    url: "https://www.worldwildlife.org/species/sea-lions",
    index: 24,
    type: "trigger",
    audioSample: "",
  },
  {
    keyboardKey: "M",
    name: "Mountain Gorilla",
    url: "https://www.worldwildlife.org/species/mountain-gorilla",
    index: 25,
    type: "trigger",
    audioSample: "",
  },
];
